<template>
  <el-dialog
    :title="activeItem.id ? '编辑信息' : '添加信息'"
    :visible.sync="$parent.dialogVisible"
    width="30%"
  >
    <el-form
      label-position="right"
      label-width="120px"
      :model="form"
      :rules="rules"
      ref="ruleForm"
    >
      <el-form-item label="意见建议标题" prop="title">
        <el-input
          v-model="form.title"
          maxlength="20"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item label="意见建议描述" prop="content">
        <el-input
          type="textarea"
          v-model="form.content"
          resize="none"
          rows="7"
          show-word-limit
          maxlength="500"
        ></el-input>
      </el-form-item>
      <el-form-item label="附件"
        ><el-button size="mini" type="primary" icon="el-icon-plus"
          >添加附件</el-button
        ></el-form-item
      >
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$parent.dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit('ruleForm')" :loading="loading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    activeItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        title: "",
        content: "",
        imageUrl: "",
      },
      rules: {
        title: [
          { required: true, message: "标题不能为空" },
          { whitespace: true, message: "标题不能为空" },
          { min: 1, max: 20, message: "请输入不超过 20 个字", trigger: "blur" },
        ],
        content: [
          { required: true, message: "描述不能为空" },
          { whitespace: true, message: "描述不能为空" },
          {
            min: 1,
            max: 500,
            message: "请输入不超过 500 个字",
            trigger: "blur",
          },
        ],
        imageUrl: [
          {
            required: true,
            message: "请选择图片并点击上传",
            trigger: "blur",
          },
        ],
      },
      loading: false,
    };
  },
  methods: {
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style></style>
